import "./HeroImgStyle.css";

import React from "react";
//import NaBar from "../components/NavBar";
//import HeroImg from "../components/HeroImg";
//import IntroImg from 'https://media.istockphoto.com/id/1128527304/photo/oil-or-gas-pipe-line-valves-oil-and-gas-extraction-production-and-transportation-industrial.jpg?s=2048x2048&w=is&k=20&c=hN0QQG65Oin_bDqBnOmbEit2ZF3hJd0_rRpSbG2wkgA=';
import {Link} from "react-router-dom";

const HeroImg = () => {
    return(
        <div className="hero">
            <div className ="mask">
                <img className ="into-img" alt=" "/>
            </div>
          <div className= "content">
              <h1>!פתרונות לסגירת מגופים</h1>
            <div>
              <Link to="/project" className="btn">פרוייקטים</Link>

              <Link to="/Contact" className="btn btn-light">צרו קשר</Link>
            
          </div>  
        </div>
        </div>
    );
}

export default HeroImg
